<template>
    <div class='pb-4 row'>
        <password-verification 
            ref='passwordVerification' 
            :item='$parent.item' 
            v-on:validated='updateItemSuccess' />
        <div v-bind:class="fullWidth()">

            <b-tabs content-class="mt-3" v-model="tabIndex">
                <b-tab :title="$t('translations.subtitle_user_details')" href="#userDetails">

                    <h2 class='section-heading' id="userDetails">{{$t('translations.subtitle_user_details')}} <span v-if='this.$parent.event == "staff"' class="small float-right">{{ $t('translations.see_settings_groups')}}</span></h2>
                    <input type='hidden' v-model='$parent.item.id'>

                    <div v-if='this.$parent.event == "staff" && this.is_network_admin() && this.$parent.type == "edit" && (this.$parent.item && this.$parent.item.user_provider && this.$parent.item.user_provider.length > 1)' class='alert alert-info'>
                        {{$t('translations.note_multi_provider_not_yet_editable')}}
                    </div>

                    <div v-if='this.$parent.event == "staff" && is_network_admin() && this.$parent.type == "create"' class="form-row">
                        <div class="form-group">
                            <label for='provider'>{{$t('translations.provider')}}</label>
                            <select v-model='provider_id' class='form-control' >
                                <option v-for="(provider) in sortByValue($root.lookup.providers, 'name')" :value="provider.id" :key="provider.id">{{provider.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class='form-row'>
                        <div class="form-group col-16">
                            <label for='email'>{{$t('translations.email')}} <span v-if='this.$parent.event == "staff"' class="required-field">*</span></label>
                            <div class='d-flex flex-row'>
                                <input type='email' v-model='$parent.item.email' class='form-control flex-grow-1'>
                                <button v-if='this.$parent.event == "staff" && this.$parent.type == "create"' :disabled='$parent.item.email ? false : true' v-on:click.prevent='checkForExistingStaff()' class="ml-2 btn btn-success btn-round" role="button">{{ $t('translations.check') }}</button>
                            </div>
                        </div>
                    </div>

                    <template v-if='this.$parent.event == "staff" && $parent.item.provider && canEditRole()'>
                        <div v-if='!this.is_network_admin() || this.$parent.type == "create" || (this.$parent.item && this.$parent.item.user_provider && this.$parent.item.user_provider.length == 1)'  class="form-row">
                            <div class="form-group col-md-10">
                                <label for='user_role'>{{$t('translations.user_role')}} <span class="required-field">*</span></label>
                                <span v-if='this.is_admin() && is_superuser($parent.item)'>Superuser</span>
                                <select v-else v-model='$parent.item.provider.user_role_id' class='form-control' >
                                    <option v-for="(value, key) in getAllowedUserRoles()" :value="value" :key="key">{{key}}</option>
                                </select>
                            </div>
                        </div>
                        <div v-else class='form-row'>
                            <div class="form-group col-md-20">
                                <label for='user_role'>{{$t('translations.user_role')}} <span class="required-field">*</span></label>
                                <div>{{this.nameLookupById("user_roles", $parent.item.provider.user_role_id)}}</div>
                                <!-- <small id="emailHelp" class="form-text text-muted">Editing of staff roles is not available for multi-provider staff by network administrators, as it isn't possible to identify which provider to update (yet).</small> -->

                            </div>
                        </div>
                    </template>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for='title'>{{$t('translations.title')}}</label>
                            <select v-model='$parent.item.user_title_id' class='form-control'>
                                <option v-for="(value, key) in $parent.related_data.user_titles" :value="key" :key="key">{{ $t('translations.'+value) }}</option>
                            </select>
                        </div>

                        <div class="form-group col-md-10">
                            <label for='forename'>{{$t('translations.forename(s)')}} <span class="required-field">*</span></label>
                    <input v-on:change='checkForDuplicates' type='text' v-model='$parent.item.forenames' class='form-control'>
                        </div>

                        <div class="form-group col-md-10">
                            <label for='surname'>{{$t('translations.surname')}} <span class="required-field">*</span></label>
                            <input v-on:change='checkForDuplicates' type='text' v-model='$parent.item.surname' class='form-control'>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-16" v-if='this.$parent.event == "patient"'>
                            <label for='dob'>{{$t('translations.DOB')}} <span class="required-field">*</span></label>
                            <vue-dob-picker v-on:change='checkForDuplicates' v-model='$parent.item.dob' />
                            <!-- <input type='date' v-model='$parent.item.dob' class='form-control' placeholder="dd/mm/yyyy"> -->
                        </div>

                        <div class="form-group col-6">
                            <label for='gender'>{{$t('translations.gender')}} <span class="required-field">*</span></label>
                                <select v-on:change='checkForDuplicates' v-model='$parent.item.gender' class='form-control'>
                                <option v-for="(value, key) in $parent.related_data.genders" :value="key" :key="key">{{$t(value)}}</option>
                            </select>
                        </div>

                        <div class="form-group col-6" v-if="this.$parent.event == 'staff'">
                            <label for='alias'>{{autobrand('translations.alias')}}</label>
                            <input type='text' v-model='$parent.item.alias' class='form-control'>

                        </div>
                    </div>

                    <div class="form-row">

                        <div v-if='this.$parent.event == "patient" && $parent.item.provider' class="form-group col-12">
                            <label for='usual_GP'>{{$t('translations.usual_GP')}}</label>
                            <select class="form-control" v-model='$parent.item.provider.preferred_clinician_id'>
                                <option v-for="user in filtered_users" :key='user.id' :value='user.id' v-text='formatNameCompliant(user)'></option>
                            </select>
                        </div>

                        <!-- <div v-if='this.$parent.type == "create" && $parent.item.email' class="form-group">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="email_notification" v-model='$parent.item.email_notification' value="1">
                                <label class="form-check-label" for="email_notification">Send welcome email?</label>
                            </div>
                        </div> -->
                    </div>

                    <!-- <div v-if='this.$parent.event == "staff" && $parent.item.provider && $root.provider && $root.provider.site && $root.provider.site.length > 1' class="form-row ">
                        <div class="form-group col-24">
                            <label for='site_id'>Preferred Site</label>
                            <b-form-radio-group
                                value-field='id'
                                text-field='name'
                                v-model="$parent.item.provider.site_id"
                                :options="$root.provider.site"
                                class='col-14'
                                button-variant="primary-outline"
                                name="site_id" />
                        </div>
                    </div> -->

                    <div v-if='this.$parent.event == "patient" && provider_id' class="form-row ">
                        <div class="form-group col-24">
                            <label for='site_id'>{{$t('translations.preferred_site')}} <span class="required-field">*</span></label>
                            <b-form-radio-group
                                value-field='id'
                                text-field='name'
                                v-model="$parent.item.provider.site_id"
                                :options="sites"
                                class='btn-block'
                                button-variant="primary-outline"
                                name="site_id" />
                        </div>
                    </div>

                    <div class="form-row">
                        <template v-if='this.$parent.event == "patient"'>
                            <div class="form-group col-md-14">
                                <label for='nhs_number'>{{$t('translations.NHS_number')}}</label>
                        <input v-on:change='checkForDuplicates' type='text' placeholder="" v-model='$parent.item.nhs_number' class='form-control'>
                                <!-- <inline-error :errors="$parent.errors" type='nhs_number'></inline-error> -->
                            </div>
                        </template>
                        <div v-if='this.$parent.event == "patient"' class="form-group col-10">
                            <label for='title'>{{$t('translations.IDStatus')}} <span class="required-field">*</span></label>
                            <select v-model='$parent.item.verification_status_id' class='form-control required' required>
                                <option v-for="(value, key) in $root.lookup.verification_statuses" :value="key" :key="key">{{$t('translations.' + value)}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for='telephone'>{{$t('translations.telephone_number')}}</label>
                            <input type='tel' v-model='$parent.item.phone_number' class='form-control'>
                        </div>

                        <div v-if='this.$parent.event == "patient"' class="form-group col-12">
                            <label for='telephone_alt'>{{$t('translations.alternative_telephone')}}</label>
                            <input id='telephone_alt' type='tel' v-model='$parent.item.phone_number_alt' class='form-control'>
                        </div>

                    </div>
                    <div class="form-row" v-if='$parent.item'>
                        <div v-if='this.$parent.event == "staff"' class="form-group col-md-12">
                            <label for='profession'>{{$t('translations.profession')}}</label>
                            <input type='text' v-model='$parent.item.profession' class="form-control">
                            <small id="emailHelp" class="form-text text-muted">{{ autobrand('translations.shown_to_patients')}}</small>
                        </div>
                        
                        <div v-if='this.$parent.event == "staff"' class="form-group col-md-12">
                            <label for='profession'>{{$t('translations.gpad_profession')}} <span class="required-field">*</span></label>
                        
                            <autocomplete v-if='$parent.related_data.professions'
                                v-model='$parent.item.profession_id' 
                                class='form-control' 
                                ref='profession_id' 
                                :source='selectorToAutocomplete(sortByKey($parent.related_data.professions))'
                                @clear='$parent.item.profession_id = null'></autocomplete>
                        </div>
                    </div>
                    <div class="form-row" v-if='$parent.item && mrs_enabled()'>
                        <div v-if='this.$parent.event == "staff"' class="form-group col-md-12">
                            <label for='mrs_user_id'>{{$t('translations.mrs_user_id')}}</label>
                            <input type='text' v-model='$parent.item.provider.mrs_user_id' class="form-control">
                        </div>
                    </div>

                    <div class="form-row">
                        <div v-if='this.$parent.event == "patient"' class="form-group col-md-8">
                            <label for='address_1'>{{ $t('translations.address_line_1')}}</label>
                            <input type='text' v-model='$parent.item.address_line_1' class='form-control'>
                        </div>

                        <div v-if='this.$parent.event == "patient"' class="form-group col-md-8">
                            <label for='address_2'>{{ $t('translations.address_line_2')}}</label>
                            <input type='text' v-model='$parent.item.address_line_2' class='form-control'>
                        </div>

                        <div v-if='this.$parent.event == "patient"' class="form-group col-md-8">
                            <label for='address_3'>{{ $t('translations.address_line_3')}}</label>
                            <input type='text' v-model='$parent.item.address_line_3' class='form-control'>
                        </div>
                    </div>

                    <div class="form-row">
                        <div v-if='this.$parent.event == "patient"' class="form-group col-md-8">
                            <label for='address_4'>{{ $t('translations.address_line_4')}}</label>
                            <input type='text' v-model='$parent.item.address_line_4' class='form-control'>
                        </div>

                        <div v-if='this.$parent.event == "patient"' class="form-group col-md-8">
                            <label for='postcode'>{{ $t('translations.postcode')}}</label>
                            <input v-on:change='checkForDuplicates' type='text' v-model='$parent.item.postcode' class='form-control text-uppercase'>
                        </div>
                    </div>

                    <div class="form-row" v-if='environment_settings.MIX_ENABLE_LANGUAGE_SELECTION'>
                        <div class="form-group col-md-12">
                            <label class="">{{ $t('translations.set_default_language')}}</label>
                            <select :class="'form-control col-md-' + (this.$parent.event == 'staff' ? 6 : 12)" v-model="$parent.item.locale" v-on:change="setLocale">
                                <option :key='key' v-for="(lang, key) in $root.lookup.langs" :value="key" placeholder="language">{{ lang }}</option>
        					</select>
                        </div>
                    </div>

                    <div v-if='this.duplicates.length' class="card mb-2">
                        <div class="card-body">
                            <h4 class="card-title"><strong>{{ $t('translations.potential_duplicate_records')}}</strong></h4>
                            <p class="card-text">
                                <ul>
                                    <li class='d-flex align-items-center mb-2' :key='duplicate.id' v-for='duplicate in this.duplicates'>
                                        <div>[{{duplicate.id}}] {{formatNameCompliant(duplicate)}}, {{duplicate.dob | formatDate}}</div>
                                        <button v-on:click.prevent='navigateToPatient(duplicate.id)' class="ml-2 btn btn-success btn-round" role="button">{{ $t('translations.view')}}</button>
                                    </li>
                                </ul>
                            </p>

                        </div>
                    </div>

                    <modal ref='relationshipDialog' name="set-relationship" :adaptive="true" :scrollable="true">
                        <div class='p-2 h-100 d-flex flex-column' style='overflow: auto'>
                            <div class="modal-header">
                                <h5 class="modal-title">{{ $t('translations.select_relationship')}}</h5>
                            </div>

                            <div class="modal-body">
                                <div class="form-inline">
                        		    <label for='name' class="col-md-8">{{ $t('translations.relationship_type')}}</label>
                                    <select v-model='new_relationship.user_relationship_type_id' class='form-control col-md-12' >
                                        <option v-for="(value, key) in $root.lookup.user_relationship_types" :value="key" :key="key">{{value}}</option>
                                    </select>
                                    <button v-on:click.prevent='relationship_next()' class="btn btn-primary btn-sm col-md-4">{{ $t('translations.add')}}</button>
                                </div>
                        	</div>
                        </div>
                    </modal>

                    <b-modal ref='patientDialog' centered size="lg" title='Search for a patient'>
                        <div class='d-flex flex-column h-100'>
                            <div>
                                <inline-filter v-on:filterUpdated='searchPatients()' ref="listFilter" route='/api/v1/patients'></inline-filter>
                            </div>
                            <div class='p-2 flex-grow-1-scroll h-100'>
                                <ul class='list list-user'>
                                    <li class='list-user_item' v-on:click='setRelationship(key)' v-for='(patient, key) in patients' :key='patient.id'>
                                        <h2 class="h6"><strong>{{formatNameCompliant(patient)}} <template v-if='patient.gender || patient.dob'>(<template v-if='patient.gender'>{{patient.gender.toUpperCase()}}</template><template v-if='patient.dob'> {{patient.dob | getAge}}</template>)</template></strong></h2>
                                        <span>{{patient.email}}&nbsp;</span>
                                        <div v-if="is_network_admin()">{{patient.provider.name}}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div slot="modal-footer" class="w-100">
                            <b-btn size="sm" class="float-left" variant="primary" v-on:click.prevent='$refs.patientDialog.hide()'>
                                {{ $t('translations.close')}}
                            </b-btn>
                        </div>
                    </b-modal>

                </b-tab>
                <b-tab v-if='$parent.item && $parent.event == "staff"' :title="$t('translations.message_settings')" href="#settings">

                    <h4 class='section-heading' id="messageSettings">{{$t('translations.message_settings')}}</h4>
                    
                    <div class="form-row" v-if='$parent.item && $parent.event == "staff"'>
                        <div v-show='true' class="form-group col-10">
                            <label for='title'>{{$t('translations.message_view')}}</label>
                            <select name='message_view' v-model='$parent.item.message_view' class='form-control required' required>
                                <option value="0">{{$t('translations.message_view_plain')}}</option>
                                <option value="1">{{$t('translations.message_view_table')}}</option>
                                <option value="2">{{$t('translations.message_view_stacked')}}</option>
                                <option value="3">{{$t('translations.message_view_list')}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-row" v-if='$parent.item && $parent.event == "staff"'>
                        <div class="form-group col-md-12">
                            <label for='default_internal_message'>{{ $t('translations.default_internal_message')}}</label>
                            <div>
                                <b-form-checkbox name='default_internal_message' size="lg" v-model="$parent.item.default_internal_message" switch></b-form-checkbox>
                            </div>
                        </div>
                    </div>
                </b-tab>

                <b-tab :title="this.$t('translations.weekly_rota')" v-if='this.$parent.item && this.$parent.event == "staff"' href="#rota">

                    <p class='alert alert-info' v-html='autobrand("translations.availability_help_text")'>
                    </p>
                    <template v-if='$parent.item.availability_date'>
                        <!-- v-if='this.$parent.type == "create" /*(this.$parent.item.user_provider && this.$parent.item.user_provider.length == 1)*/ || this.$parent.item.id == this.$root.user.id'> -->
                        <h4 class='section-heading'>{{ $t('translations.weekly_rota')}}</h4>
                        <div v-if="this.$parent.item.availability_date" class="pb-2 form-group">
                            <table class='availability table'>
                                <thead class="thead-light">
                                    <tr>
                                        <th style="min-width:100px;width:130px;">{{ $t('translations.day_of_week')}}</th>
                                        <th style="min-width:225px;width:230px;">{{ $t('translations.availability')}}</th>
                                        <th style="min-width:100px;">{{ $t('translations.site')}}</th>
                                        <th style="min-width:100px;width:100px;">{{ autobrand('translations.capacity_requests')}}</th>
                                        <th style="min-width:100px;width:100px;">&nbsp;</th>
                                    </tr>
                                </thead>
                                <template v-for="(day, day_of_week) in $root.lookup.dayNames">

                                    <tr :key='day_of_week' class='day_heading'>
                                        <td :colspan='4'>{{ day | capitalise}}</td>
                                        <td>
                                            <button v-on:click.prevent='addDayAvailability(day_of_week)' class="btn btn-primary btn-block btn-round btn-sm">{{ $t('translations.add')}}</button>
                                        </td>
                                    </tr>
                                    <template v-if='getAvailabilityIndexes($parent.item.availability_date, day_of_week).length'>
                                        <template v-for='(date_index) in getAvailabilityIndexes($parent.item.availability_date, day_of_week)'>
                                            <template v-if='$parent.item.availability_date[date_index].availability_time.filter(obj => {return $root.provider.site.find(site => {return (is_network_admin() || site.id == obj.site_id)})}).length'>
                                                <template v-for='(time, index) in $parent.item.availability_date[date_index].availability_time'>
                                                    <tr v-if='is_network_admin() || $root.provider.site.find(site => {return site.id == time.site_id})' :key='$parent.item.availability_date[date_index].id + "-" + index' class='day_value'>
                                                        <td>&nbsp;</td>
                                                        <td :key='"time-" + $parent.item.availability_date[date_index].id + "-" + index'>
                                                            <ul class="availability-time">
                                                                <li :key='$parent.item.availability_date[date_index].id + "-" + index'>
                                                                    <input class="form-control-inline" type='time' :name='$parent.item.availability_date[date_index].date_from + "-" + index + "-from"' v-model="$parent.item.availability_date[date_index].availability_time[index].from">
                                                                    -
                                                                    <input class="form-control-inline" type='time' :name='$parent.item.availability_date[date_index].date_from + "-" + index + "-to"' v-model="$parent.item.availability_date[date_index].availability_time[index].to">
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td :key='"site-" + $parent.item.availability_date[date_index].id + "-" + index'>
                                                            <select class="form-control-inline" v-model="$parent.item.availability_date[date_index].availability_time[index].site_id">
                                                                <option :key='$parent.item.availability_date[date_index].id + "-" + index + "-" + site.id' v-for="site in sites" v-bind:value="site.id">
                                                                    {{ site.name }}
                                                                </option>
                                                            </select>
                                                        </td>
                                                        <td :key='"capacity-" + $parent.item.availability_date[date_index].id + "-" + index'>
                                                            <input class="form-control-inline input-capacity" type="number" min="0" v-model='$parent.item.availability_date[date_index].availability_time[index].capacity'>
                                                        </td>
                                                        <td>
                                                            <button v-on:click.prevent='deleteDayAvailability(date_index, index)' class="btn btn-danger btn-sm btn-round btn-block">{{ $t('translations.remove')}}</button>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <tr :key='$parent.item.availability_date[date_index].id + "-none"'>
                                                    <td colspan='4'>{{ $t('translations.no_availability')}}</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <tr :key='day + "-none"'>
                                            <td colspan='4'>{{ $t('translations.no_availability')}}</td>
                                        </tr>
                                    </template>
                                </template>
                            </table>
                        </div>
                        <p v-else>
                            {{ $t('translations.no_standard_availability')}}
                        </p>
                        <h4 class='section-heading'>{{ $t('translations.availability_exceptions')}}</h4>
                        <div class="pb-2 form-group">
                            <p class='alert alert-info'>
                                {{ $t('translations.alert_info_weekly_rota_part1')}}
                                <span class='text-nowrap'>9:00 - 12:00</span>.
                                {{ $t('translations.alert_info_weekly_rota_part2')}}
                                <span class='text-nowrap'>9:00 - 11:00</span>
                                {{ $t('translations.alert_info_weekly_rota_part3')}}
                                <span class='text-nowrap'>14:00 - 17:00.</span>
                                {{ $t('translations.alert_info_weekly_rota_part4')}}
                            </p>
                            <table class='availability table'>
                                <thead class="thead-light">
                                    <tr>
                                        <th>{{ $t('translations.start_date')}}</th>
                                        <th>{{ $t('translations.end_date')}}</th>
                                        <th>{{ $t('translations.availability')}}</th>
                                        <th>{{ $t('translations.site')}}</th>
                                        <th>{{ autobrand('translations.capacity_requests')}}</th>

                                        <th style='width: 15%'>
                                            <button v-on:click.prevent='addAvailability()' class="btn btn-primary btn-block btn-round btn-sm">{{ $t('translations.add')}}</button>
                                        </th>
                                    </tr>
                                </thead>
                                <template v-if='getAvailabilityExceptionIndexes($parent.item.availability_date).length'>
                                    <template v-for='(date_index) in getAvailabilityExceptionIndexes($parent.item.availability_date)'>
                                        <tr v-if='$parent.item.availability_date[date_index].availability_time.filter(obj => {return $root.provider.site.find(site => {return (is_network_admin() || site.id == obj.site_id)})}).length' :key='$parent.item.availability_date[date_index].id + "-" + date_index' class='day_value'>
                                            <td>
                                                <!-- <datetime value-zone='local' placeholder='DD/MM/YYYY' type='date' format='dd/MM/yyyy' auto v-model="$parent.item.availability_date[date_index].date_from"></datetime> -->
                                                <input class='form-control-inline' type='date' v-model='$parent.item.availability_date[date_index].date_from'>
                                            </td>
                                            <td>
                                                <!-- <datetime value-zone='local' placeholder='DD/MM/YYYY' type='date' format='dd/MM/yyyy' auto v-model="$parent.item.availability_date[date_index].date_to"></datetime> -->
                                                <input class='form-control-inline' type='date' v-model='$parent.item.availability_date[date_index].date_to'>
                                            </td>
                                            <td>
                                                <ul>
                                                    <template v-for='(time, index) in $parent.item.availability_date[date_index].availability_time'>
                                                        <li :key='$parent.item.availability_date[date_index].id + "-" + index'>
                                                            <div class="d-flex">
                                                                <input class='form-control-inline' type='time' :name='$parent.item.availability_date[date_index].date_from + "-" + index + "-from"' v-model="$parent.item.availability_date[date_index].availability_time[index].from">
                                                                <div class='pl-2 pr-2'>-</div>
                                                                <input class='form-control-inline' type='time' :name='$parent.item.availability_date[date_index].date_from + "-" + index + "-to"' v-model="$parent.item.availability_date[date_index].availability_time[index].to">
                                                            </div>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </td>
                                            <td>
                                                <select class='form-control-inline' v-model="$parent.item.availability_date[date_index].availability_time[0].site_id">
                                                    <option :key='date_index + "-" + site.id' v-for="site in sites" v-bind:value="site.id">
                                                        {{ site.name }}
                                                    </option>
                                                </select>
                                            </td>
                                            <td>
                                                <input class='form-control-inline input-capacity' type="number" min="0" v-model='$parent.item.availability_date[date_index].availability_time[0].capacity'>
                                            </td>

                                            <td>
                                                <button v-on:click.prevent='deleteAvailability(date_index)' class="btn btn-danger btn-sm btn-round btn-block">Remove</button>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                <template v-else>
                                    <tr key="exceptions-none">
                                        <td colspan='4'>{{$t('translations.no_availibility_exceptions_found')}}</td>
                                    </tr>
                                </template>
                            </table>
                        </div>
                    </template>
                    <!-- <div v-else class='alert alert-info'>
                        Editing of staff rotas is not available because the user being edited has multi-provider access. Only the account owner can change their own rota in this case.
                    </div> -->
                </b-tab>

                <b-tab v-if='appointmentsEnabled() && $parent.item && $parent.event == "staff"' :title="this.$t('translations.appointment_settings')" href="#appointments">

                    <h4 class='section-heading'>{{ $t('translations.appointment_session_types')}}</h4>

                    <appointment-session-type-table
                        v-model='$parent.item.appointment_session_type' :edit='true' />

                    <hr>

                    <h4 class='section-heading'>{{ $t('translations.appointment_sessions') }}</h4>
                    <!-- <router-link to="/appointments" class="btn btn-icon-left btn-round btn-primary float-right"><span class="icon icon-calendar"></span>{{ $t('translations.buttonViewAppointmentsCalendar') }}</router-link> -->
                    <appointment-session-table
                        v-model='$parent.item.appointment_session'
                        :appointment_session_type='$parent.item.appointment_session_type' :edit='true' />



                </b-tab>
                <b-tab v-if='$parent.item && $parent.event == "staff" && $parent.type == "edit"' :title="$t('translations.user_groups')" href="#userGroups">

                    <h4 class='section-heading' id="userGroups">{{$t('translations.user_groups')}}</h4>
                    <template v-for='user_group in sortByValue(lookup_user_groups, "name")'>
                        <div class="ml-4 form-check" :key="user_group.id">
                            <input class="form-check-input" type="checkbox" :id='"defaultCheck" + user_group.id' :value="user_group.id" v-model='user_groups[user_group.id]' >
                            <label class="form-check-label" :for='"defaultCheck" + user_group.id'>
                                {{user_group.name}}
                            </label>
                        </div>
                    </template>
                </b-tab>
            </b-tabs>
        </div>

        <div class="col-md-10">
            <template v-if='this.$parent.event == "patient"'>
                <h4 class='section-heading'>{{ tBrand('is_proxy_for') }}:</h4>
                <table class='availability table table-bordered'>
                    <tr>
                        <th rowspan='2'>{{ $t('translations.name')}}</th>
                        <th rowspan='2'>{{ $t('translations.relationship')}}</th>
                        <th>{{ $t('translations.actions')}}</th>
                    </tr>
                    <tr>
                        <td class=''><a class="w-100 btn btn-primary btn-sm text-white" v-on:click='selectCaree'>{{ $t('translations.add')}}</a></td>
                    </tr>
                    <template v-if='this.$parent.item.carees && this.$parent.item.carees.length > 0'>
                        <tr :key='relationship.id'  v-for='(relationship, key) in this.$parent.item.carees'>
                            <td>{{formatNameCompliant(relationship)}}</td>
                            <td>{{$root.lookup.user_relationship_types[relationship.user_relationship_type_id]}}</td>
                            <td><a class="btn btn-danger btn-sm btn-block text-white" v-on:click='removeCaree(key)'>{{ $t('translations.remove')}}</a></td>
                        </tr>
                    </template>
                    <tr v-else><td colspan='3'>{{ $t('translations.none_listed')}}</td></tr>
                </table>
                <!-- <button class="btn btn-
                primary" v-on:click.prevent='openAddRelationship' role="button">Add Relationship</button> -->
                <h4 class='section-heading'>{{ $t('translations.in_care_of')}}:</h4>
                <table class='availability table table-bordered'>
                    <tr>
                        <th rowspan='2'>{{ $t('translations.name')}}</th>
                        <th rowspan='2'>{{ $t('translations.relationship')}}</th>
                        <th>{{ $t('translations.actions')}}</th>
                    </tr>
                    <tr>
                        <td><a class="w-100 btn btn-primary btn-sm text-white" v-on:click='selectCarer'>{{ $t('translations.add')}}</a></td>
                    </tr>
                    <template v-if='this.$parent.item.carers && this.$parent.item.carers.length > 0'>
                        <tr :key='relationship.id' v-for='(relationship, key) in this.$parent.item.carers'>
                            <td>{{formatNameCompliant(relationship)}}</td>
                            <td>{{$root.lookup.user_relationship_types[relationship.user_relationship_type_id]}}</td>
                            <td><a class="btn btn-danger btn-sm btn-block text-white" v-on:click='removeCarer(key)'>{{ $t('translations.remove')}}</a></td>
                        </tr>
                    </template>
                    <tr v-else><td colspan='3'>{{ $t('translations.none_listed')}}</td></tr>
                </table>
                <h4 class='section-heading'>{{ $t('translations.tags') | capitalise }}:</h4>
                
                <div class="form-group">
                    
                    <div class='d-flex flex-row'>
                        <autocomplete class='align-self-stretch form-control'
                                v-model='tag'
                                ref='ac'
                                :source="patientTags"
                                @clear='tag = null'
                                :resultsDisplay='tagResultDisplay'
                                :request-headers="authHeaders"
                                @selected='setDisplayValue'
                                @close='setDisplayValue'
                                >
                        </autocomplete>
                        <!-- <div v-if='tag' class='icon-preview'>
                            <i :class='"pr-1 fa fa-2x fa-" + tag.icon'></i>
                        </div> -->
                        <!-- <button :disabled='!tag' class="align-self-stretch btn btn-primary btn-sm text-white" v-on:click.prevent='addTag'>{{ $t('translations.add')}}</button> -->
                    </div>
                    <div>
                        <div :key='tag.tag_id' v-for='(tag, index) in $parent.item.user_tag' class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                            <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                            <a v-on:click.prevent='$parent.item.user_tag.splice(index,1)' href="#">&times;</a>
                        </div>
                    </div>        
                </div>
            </template>
        </div>
    </div>
</template>

<script>
	export default {
		props: {
            title: {
                default: null
            },
            item: {

            },
            model: {

            },
            route: {

            },
            originalData: {

            }
		},
		data: function(){
			return {
                userSearchTerm: "",
                patients: [],
                new_relationship: {},
                relationship_next: null,
                filterFields: null,
                duplicates: [],
                provider_id: 1,
                sites: [],
                tabIndex: 0,
                tabs: ['#userDetails', '#system', '#rota', '#appointments', '#userGroups'],
                locale: window.default_locale,
                user_groups: {},
                lookup_user_groups: [],
                tag: null,
			};
		},
        computed: {
            filtered_users() {
                return this.$root.lookup.staff.filter(staff => {
                    return this.isMemberOfAssignableGroup(staff);
                });
            },
            authHeaders () {
                return {
                    'Authorization': axios.defaults.headers.common['Authorization'],
                    'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                }
            },
            patientTags() {
                return this.$root.lookup.tags.filter(obj => {
                    return obj.tags_tag_use.find(obj2 => {
                        return obj2.tag_use.name == 'client'
                    })
                });
            }
        },
        watch: {
            provider_id() {
                this.$parent.item.provider.id = this.provider_id;

                if(this.$parent.event == 'patient') {
                    this.sites = this.getSites(this.provider_id);
                }
                else {
                    if(this.is_network_admin()) {
                        this.sites = this.getSites();
                    }
                    else {
                        this.sites = this.getSites(this.provider_id);
                    }
                }

                var default_site = this.sites[0].id;

                for(var dIndex in this.$parent.item.availability_date) {
                    for(var index in this.$parent.item.availability_date[dIndex].availability_time) {
                        this.$parent.item.availability_date[dIndex].availability_time[index].site_id = default_site;
                    }
                }

            },
            "$parent.item.profession_id"() {
                if(this.$refs.profession_id) {
                    this.$refs.profession_id.display = this.nameLookupById(this.$parent.related_data.professions, this.$parent.item.profession_id);
                }
            },
            "$root.lookup.tags"() {
                if(this.$parent.item && this.$parent.item.user_tag && Array.isArray(this.$parent.item.user_tag)) {
                    this.$parent.item.user_tag.forEach((obj, index) => {
                        if(!this.getTag(obj.tag_id).name) {
                            this.$parent.item.user_tag.splice(index, 1);
                        }
                    })
                }
            }
            // "$parent.item.availability_date"() {
            //     alert("WOW");
            // }
        },
        mounted() {
            if(this.$parent.item && this.$parent.item.provider) {
                this.provider_id = this.$parent.item.provider.id;
            }

            var tab = this.tabs.findIndex(tab => tab === this.$route.hash);

            if(tab == -1) {
                tab = this.tabs.findIndex(tab => tab === "#" + this.$route.params["tab"]);
            }
            if(tab != -1) {
                this.tabIndex = tab;
            }          

        },

        methods : {
            
            isMemberOfAssignableGroup(user) {
                for(var index in this.$root.lookup.user_groups) {
                    if(this.$root.lookup.user_groups[index].members_assignable) {
                        for(var userIndex in this.$root.lookup.user_groups[index].usersusergroup) {
                            if(this.$root.lookup.user_groups[index].usersusergroup[userIndex].user_id == user.id) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            searchPatients() {
                var filters = this.copyNonReactive(this.$refs.listFilter.appliedFilters);
                if(this.$parent.item.id) {
                    filters.push({"id":999,"field":"id","type":"!=","value":this.$parent.item.id,"title":"user_id"})
                }
                var search = encodeURIComponent(JSON.stringify(filters));


                this.$root.setLoading(true);
                axios.get('/api/v1/patients' + '?search=' + search).then((res) => {
	                this.patients = res.data.data;
                    this.$root.setLoading(false);
				}).catch(error => {
					this.$root.setLoading(false);
                    this.handleError(error, "load");
				});
            },
            selectCaree() {
                this.relationship_next = this.addCaree;
                this.patients = [];
                this.$refs.patientDialog.show();
                Vue.nextTick(() => {
                    this.$refs.listFilter.filterFields = this.filterFields;
                    this.$refs.listFilter.clearFilters(null);
                });


            },
            selectCarer() {
                this.relationship_next = this.addCarer;
                this.patients = [];
                this.$refs.patientDialog.show();
                Vue.nextTick(() => {
                    this.$refs.listFilter.filterFields = this.filterFields;
                    this.$refs.listFilter.clearFilters(null);
                });

            },
            setRelationship(key) {
                this.new_relationship = this.patients[key];
                this.new_relationship.user_relationship_type_id = 1;
                this.$refs.patientDialog.hide();
                this.$modal.show('set-relationship');
            },
            setCarerRelationship(key) {
                this.new_relationship = this.patients[key];
                this.new_relationship.user_relationship_type_id = 1;
                this.$refs.patientDialog.hide();
                this.$modal.show('set-relationship');
            },
            addCaree() {
                this.$modal.hide('set-relationship');
                this.$parent.item.carees.push(this.new_relationship);
            },
            addCarer() {
                this.$modal.hide('set-relationship');
                this.$parent.item.carers.push(this.new_relationship);
            },
            removeCaree(key) {
                this.$parent.item.carees.splice(key, 1);

            },
            removeCarer(key) {
                this.$parent.item.carers.splice(key, 1);
            },
            addAvailability() {
                this.$parent.item.availability_date.push({
                    "id":-(this.$parent.item.availability_date.length),
                    "date_from":"",
                    "day_of_week": null,
                    "date_to":null,
                    "availability_time": [{
                        capacity:0,
                        from:null,
                        to:null,
                        site_id:this.$root.provider.site[0].id
                    }]
                });
                //this.$parent.item.availability.push({"date_from":"","date_to":null});
            },
            addDayAvailability(day_of_week) {
                var availability_date = this.$parent.item.availability_date.find(obj => obj.day_of_week == day_of_week);

                if(!availability_date) {
                    availability_date = {
                        id:-(this.$parent.item.availability_date.length),
                        date_from:
                        null,
                        day_of_week: day_of_week,
                        date_to: null,
                        "availability_time": []
                    };
                    this.$parent.item.availability_date.push(availability_date);
                }
                availability_date.availability_time.push({
                    capacity:0,
                    from:null,
                    to:null,
                    site_id:this.$root.provider.site[0].id
                });
                //this.$parent.item.availability.push({"date_from":"","date_to":null});
            },
            deleteAvailability(index) {
                console.log(index);
                console.log(this.$parent.item.availability_date);

                this.$parent.item.availability_date.splice(index, 1);
                console.log(this.$parent.item.availability_date);
            },
            deleteDayAvailability(date_index, time_index) {
                console.log(date_index);
                console.log(time_index);
                console.log(this.$parent.item.availability_date[date_index].availability_time);

                this.$parent.item.availability_date[date_index].availability_time.splice(time_index, 1);
                console.log(this.$parent.item.availability_date[date_index].availability_time);
            },
            getName() {
                if(this.title) {
                    return this.title;
                }
                if(this.$parent.item.surname) {
                    return this.$parent.item.surname + ", " + this.$parent.item.forenames;
                }
                return "";
            },
            resetItem() {
                axios.get(this.$parent.route + '/getFilters').then((res) => {
                    this.filterFields = res.data;
                    delete(this.filterFields["verification_status_id"]);
                    delete(this.filterFields["id"]);
                });
                if(this.is_network_admin()) {
                    this.provider_id = this.$root.lookup.providers[Object.keys(this.$root.lookup.providers)[0]].id;
                }
                else {
                    this.provider_id = this.$root.provider.id;
                }

                if(this.$parent.event == 'patient') {
                    this.sites = this.getSites(this.provider_id);
                }
                else {
                    // Formerly we called this function without the provider_id for staff members
                    // which allows us to set rota for all providers and sites in one go.
                    // This has now been removed.

                    // this.sites = this.getSites();
                    if(this.is_network_admin()) {
                        this.sites = this.getSites();
                    }
                    else {
                        this.sites = this.getSites(this.provider_id);
                    }
                    
                }

                var default_site = this.sites[0].id;

                if(this.$parent.event == "staff") {
                    this.$parent.item = {capacity: [], id: "", forenames: "", alias: "", email: "", users: [], availability_date: [], appointment_session_type: [], appointment_session: [], provider: {id: this.provider_id, site_id: default_site, user_role_id: null}, profession_id: null};


                    //this.$parent.item.availability = new this.days;
                    this.$parent.item.availability_date = [
                        {"id": -1,"provider_id":null,"date_from":null,"day_of_week":1,"date_to":null,
                            "availability_time":[{"availability_date_id":-1,"site_id":default_site,capacity: 0,"from":"08:00","to":"18:30"}]},

                        {"id": -2,"provider_id":null,"date_from":null,"day_of_week":2,"date_to":null,
                            "availability_time":[{"availability_date_id":-2,"site_id":default_site,capacity: 0,"from":"08:00","to":"18:30"}]},

                        {"id": -3,"provider_id":null,"date_from":null,"day_of_week":3,"date_to":null,
                            "availability_time":[{"availability_date_id":-3,"site_id":default_site,capacity: 0,"from":"08:00","to":"18:30"}]},

                        {"id": -4,"provider_id":null,"date_from":null,"day_of_week":4,"date_to":null,
                            "availability_time":[{"availability_date_id":-4,"site_id":default_site,capacity: 0,"from":"08:00","to":"18:30"}]},

                        {"id": -5,"provider_id":null,"date_from":null,"day_of_week":5,"date_to":null,
                            "availability_time":[{"availability_date_id":-5,"site_id":default_site,capacity: 0,"from":"08:00","to":"18:30"}]},

                        {"id": -6,"provider_id":null,"date_from":null,"day_of_week":6,"date_to":null,
                            "availability_time":[{"availability_date_id":-6,"from":null,"to":null}]},

                        {"id": -7,"provider_id":null,"date_from":null,"day_of_week":7,"date_to":null,
                            "availability_time":[{"availability_date_id":-7,"from":null,"to":null}]}];

                    for(var dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
    					if(!this.$parent.item.capacity.find(obj => {return obj.day_of_week == dayOfWeek})) {
    						this.$parent.item.capacity.push({"user_id":this.$parent.item.id,"day_of_week":dayOfWeek,"capacity":0});
    					}
    				}
                }
                else {
                    this.$parent.item = {id: "", forenames: "", email: "", alias: "",  gender: "", provider_id: "", verification_status_id: 1, carees: [], carers: [], user_tag: [], provider: {id: this.provider_id, site_id: this.sites[0].id}};
                }
                
                this.$parent.originalData = JSON.parse(JSON.stringify(this.$parent.item));
            },
            loadItem(id) {
                this.$parent.setLoading(true);
                axios.get(this.$parent.route + '/getFilters').then((res) => {
                    this.filterFields = res.data;
                    delete(this.filterFields["verification_status_id"]);
                    delete(this.filterFields["id"]);
				});
                axios.get(this.$parent.route + '/' + id).then((res) => {
                    //this.$parent.item = res.data[this.$parent.model];
                    for (var attrname in res.data[this.$parent.model]) {
    					//console.log("Setting " + attrname + " to " + res.data[this.$parent.model][attrname]);
    					this.$parent.item[attrname] = res.data[this.$parent.model][attrname];
    				}
                    //this.$parent.item["dob"] = new Date(this.$parent.item["dob"]);
                    if(this.$root.provider && this.$root.provider.site && this.$root.provider.site.length == 1) {
                        this.$parent.item.site_id = this.$root.provider.site[0].id;
                    }
                    if(!this.$parent.item.capacity) {
    					this.$parent.item.capacity = [];
    				}
    				for(var dayOfWeek = 1; dayOfWeek <= 7; dayOfWeek++) {
    					if(!this.$parent.item.capacity.find(obj => {return obj.day_of_week == dayOfWeek})) {
    						this.$parent.item.capacity.push({"user_id":this.$parent.item.id,"day_of_week":dayOfWeek,"capacity":0});
    					}
                    }
                    
                    this.sites = this.getSitesFromUser(this.$parent.item, this.is_network_admin() ? undefined : this.provider_id);
                    if(this.is_network_admin()) {
                        this.lookup_user_groups = []
                        this.$parent.item.user_provider.forEach(item => {
                            item.user_group.forEach(group => {
                                group.name = item.name + ": " + group.name;
                                this.lookup_user_groups.push(group);
                            });
                            //this.lookup_user_groups = this.lookup_user_groups.concat(item.user_group);
                        });
                    }
                    else {
                        this.lookup_user_groups = this.$root.lookup.user_groups;
                    }
                    if(this.$parent.item.user_group) {
                        this.lookup_user_groups.forEach((group, index) => {
                            this.user_groups[group.id] = this.$parent.item.user_group.find(obj => {return group.id == obj.user_group_id}) ? 1 : 0;
                        })  
                    }

                    this.$parent.item.default_internal_message = this.$parent.item.default_internal_message ? true : false;

                    //console.warn(this.$parent.item.provider);
                    this.$parent.item.provider = {
                        id: this.$parent.item.provider.id,
                        site_id: this.$parent.item.provider.site_id,
                        mrs_user_id: this.$parent.item.provider.mrs_user_id,
                        // Server side check for allowing this
                        user_role_id: this.$parent.item.provider.user_role_id,
                    }
                    for(var index in this.$parent.item.user_provider) {
                        this.$parent.item.user_provider[index] = {
                            id: this.$parent.item.user_provider[index].id,
                            user_group: this.$parent.item.user_provider[index].user_group ? this.$parent.item.user_provider[index].user_group : null,
                        }
                    }
                    //console.warn(this.$parent.item.user_provider);
                    
                    this.$parent.originalData = JSON.parse(JSON.stringify(this.$parent.item));
                
                    this.$parent.setLoading(false);

				}).catch((error) => {
                    this.$parent.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/" + this.$parent.event + "-list"});
                });
            },
            updateItemSuccess(current_password) {
                
                this.$parent.setLoading(true);
                this.$parent.item.user_group = this.user_groups;
                this.$parent.item.current_password = current_password;
                axios.put(this.$parent.route + '/' + this.$parent.item.id, this.$parent.item).then((res) => {
                    this.$parent.setLoading(false);
                    this.$parent.addNotification({type: "success", content: this.$parent.elementname + " " + this.$parent.getName() + " " + this.$t('translations.notification_updated_successfully') + "."});
                    this.$parent.originalData = null;
                    this.$parent.closePanel(true);
                }).catch((error) => {
                    console.log("error: " + JSON.stringify(error, null, 2));
                    this.$parent.setLoading(false);
                    this.$parent.handleError(error, "update", this.$parent.event + "-list");
                    this.$parent.$refs.editScroller.scrollTop = 0;
                });
            },
            updateItem(event) {
                if(this.$parent.item.id == this.$root.user.id && this.$parent.item.email != this.$root.user.email) {
                    this.setLoading(true);
                    return axios.post('/api/v1/staff/updateValidateNoCP', this.$parent.item).then((res) => {
                        this.errors = [];
                        this.setLoading(false);
                        this.$refs.passwordVerification.show();
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "update");
                        this.scrollFirstError();
                    });
                }
                else {
                    this.updateItemSuccess();
                }
            },
            createItem(event) {
                
                this.$parent.setLoading(true);
                this.$parent.item.user_group = this.user_groups;
                axios.post(this.$parent.route, this.$parent.item).then((res) => {
                    this.$parent.originalData = JSON.parse(JSON.stringify(this.$parent.item));
                    this.$parent.setLoading(false);

                    this.$parent.addNotification({type: "success", content: this.$parent.elementname + " " + this.$parent.getName() + " " + this.$t('translations.notification_created_successfully') + "."});
                    console.log(res.data);
                    this.$parent.item.id = res.data.id;
                    this.$parent.originalData = null;
                    this.$parent.closePanel(true);
                }).catch((error) => {
                    this.$parent.setLoading(false);
                    this.$parent.handleError(error, "create");
                    this.$parent.$refs.editScroller.scrollTop = 0;
                });
            },

            getAllowedUserRoles() {
                if(this.is_superuser() || this.is_network_admin()) {
                    return {
                        "Superuser": this.$root.lookup.user_roles.Superuser,
                        "Admin": this.$root.lookup.user_roles.Admin,
                        "User": this.$root.lookup.user_roles.User}
                }
                else if(this.is_admin()) {
                    return {
                        "Admin": this.$root.lookup.user_roles.Admin,
                        "User": this.$root.lookup.user_roles.User
                    }
                }
                else return {};

            },
            canEditRole() {
                return (
                    this.is_superuser()
                    || this.is_network_admin()
                    || (
                        this.is_admin()
                        && (
                            this.$parent.type == "create" || this.is_admin(this.$parent.item) || this.is_user(this.$parent.item)
                            // This last one is a special case for staff users with no role set (which happened because
                            // of a bug in the create - so this lets us clean up those buggy users in the edit)
                            || (this.$parent.item.provider && !this.$parent.item.provider.user_role_id)
                        )
                    ));
            },

            setMinDate() {
                return (moment().diff(value, 'years', false) - 120 );
            },

            fullWidth() {
                if(this.$parent.event == 'patient') {
                    return 'col-14';
                } else {
                    return 'col-24';
                }
            },

            checkForDuplicates() {
                if(this.$parent.event == "patient") {
                    var data = {
                        surname: this.$parent.item.surname,
                        dob: this.$parent.item.dob,
                        gender: this.$parent.item.gender,
                        forenames: this.$parent.item.forenames,
                        postcode: this.$parent.item.postcode,
                        nhs_number: this.$parent.item.nhs_number
                    }

                    if(this.$parent.item.id) {
                        data.id = this.$parent.item.id;
            }

                    if(data.surname && data.dob && data.gender) {
                        axios.post(this.$parent.route + '/checkDuplicate', data).then((res) => {
                            console.info(res.data);
                            if(res.data.duplicates) {
                                this.duplicates = res.data.duplicates;
                            }
                        });
                    }
                }
            },
            navigateToPatient(id) {
                this.$modal.show('dialog', {
					title: 'View Duplicate',
					text: "You are about to navigate away from this page and lose your edits. Are you sure you want to do this?",
					buttons: [
					{
						title: 'Yes',
						handler: () => {
                            this.$modal.hide('dialog');
							this.$router.push({path: "/patient-list/patient-show/" + id});
						},
					},
					{
						title: 'Cancel',
						default: true
					}]});

            },
            grantAccess(id) {
                var data = {
                    id: id,
                    provider_id: this.$parent.item.provider.id
                };
                this.$parent.setLoading(true);
                axios.put(this.$root.apiBase + '/staff/grantAccess', data).then((res) => {
                    this.$parent.setLoading(false);
                    this.addNotification({type: "success", content: "Staff member has been granted access."});
                    this.$parent.$parent.getResults();
                    this.$parent.originalData = null;
                    this.$router.push({path: "/staff-list/staff-show/" + id});
                }).catch((error) => {
                    this.$parent.setLoading(false);
                    this.handleError(error, "merge");
                });

            },
            checkForExistingStaff() {
                if(this.$parent.item.email) {
                    var $data = {
                        email: this.$parent.item.email,
                        provider_id: this.$parent.item.provider.id
                    };
                    axios.get(this.$parent.route + '/checkExisting', {params: $data}).then((res) => {
                        console.log(res.data);
                        if(res.data.user && res.data.user.provider && res.data.user.provider.id) {
                            this.$modal.show('dialog', {
                                title: 'Existing Staff Member Found',
                                text: "A staff member already exists registered to this provider.",
                                buttons: [
                                {
                                    title: 'View Existing User',
                                    handler: () => {
                                        this.$modal.hide('dialog');
                                        this.$parent.originalData = null;
                                        this.$router.push({path: "/staff-list/staff-show/" + res.data.user.id});
                                    },
                                },
                                {
                                    title: 'Close',
                                    default: true
                                }]});
                        }
                        else {
                            this.$modal.show('dialog', {
                            title: 'Existing Staff Member Found',
                            text: "A registered staff member already exists with this email address at a different provider. Would you like to give them access to your " + this.tBrand("app_name") + "provider account? This will allow them to log in and view patients and requests.",
                            buttons: [
                            {
                                title: 'Yes',
                                handler: () => {
                                    this.$modal.hide('dialog');
                                    this.$parent.originalData = null;
                                    this.grantAccess(res.data.user.id);
                                },
                            },
                            {
                                title: 'No',
                                default: true
                            }]});
                        }
                    }).catch(reason => {
                        console.error(reason);
                        this.$modal.show('dialog', {
                        title: 'No Existing Staff Member Found',
                        text: "No existing accounts have been found with this email address.",
                        buttons: [
                        {
                            title: 'Close',
                            default: true
                        }]});
                    });
                }
            },
            deleteItem(event) {
                var deleteText = "You are about to delete " + this.$parent.elementname.toLowerCase() + " " + this.$parent.getName() + ". " + this.$t('translations.are_you_sure_you_want_to_continue');
                var deleteTitle = 'Delete ' + this.$parent.elementname;
                if(this.$parent.item.user_provider.length > 1) {
                    deleteText = this.autobrand('translations.you_are_about_to_remove_access_to_provider_account_for') + " " + this.$parent.elementname.toLowerCase() + " " + this.$parent.getName() + ". " + this.$t('translations.are_you_sure_you_want_to_continue');
                    deleteTitle = 'Remove ' + this.$parent.elementname + ' Access';
                }

                this.$modal.show('dialog', {
                    title: deleteTitle,
                    text: deleteText,
                    buttons: [
                    {
                        title: 'Yes',
                        handler: () => {
                            this.$modal.hide('dialog');
                            this.setLoading(true);
                            axios.delete(this.$parent.route + '/' + this.$parent.item.id).then((res) => {
                                console.log(res.data);
                                this.$parent.setLoading(false);
                                this.addNotification({type: "success", content: this.$parent.elementname + " " + this.$parent.getName() + " " + this.$t('translations.notification_deleted_successfully') + "."});
                                this.$parent.item.id = null;
                                this.$parent.originalData = null;
                                this.$parent.closePanel(true);
                            }).catch((error) => {
                                this.$parent.setLoading(false);
                                this.handleError(error, "delete");
                            });
                        },
                    },
                    {
                        title: 'Cancel',
                        default: true
                    }]});
            },
            setLocale() {
                if(this.$parent.item.id == this.$root.user.id) {
                    Vue.nextTick(() => {
                        this.$root.setLocale(this.$parent.item.locale);
                    });
                }
            },
            setDisplayValue() {
                Vue.nextTick(() => {
                    if(this.$refs.ac.value) {
                        var tag = this.$root.lookup.tags.find(obj => {return obj.id == this.$refs.ac.value});
                        if(tag) {
                            //this.$refs.ac.display = tag.name;
                            this.addTag();
                            //this.$refs.ac.clear();

                        }
                    }
                });
            },
            addTag() {
                if(!this.$parent.item.user_tag.find(obj => {return obj.tag_id == this.tag})) {
                    this.$parent.item.user_tag.push({tag_id: this.tag});
                }
                this.tag = null; 
                this.$refs.ac.clear();
            },
            mrs_enabled() {
                if(this.is_network_admin()) {
                    return false;
                }
                else {
                    return this.$root.provider.record_system_integration_type_id;
                }
            }


        }
    }
</script>
